import * as React from 'react';

const NeutralFace48 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 48 48", width: 48, height: 48, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M14.278 30.722c0-.69.56-1.25 1.25-1.25h16.944a1.25 1.25 0 0 1 0 2.5H15.528c-.69 0-1.25-.56-1.25-1.25m2.782-9.498a2.313 2.313 0 1 0 0-4.626 2.313 2.313 0 0 0 0 4.626m13.88 0a2.313 2.313 0 1 0 0-4.626 2.313 2.313 0 0 0 0 4.626"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M43 24c0 10.493-8.507 19-19 19S5 34.493 5 24 13.507 5 24 5s19 8.507 19 19M24 40.5c9.113 0 16.5-7.387 16.5-16.5S33.113 7.5 24 7.5 7.5 14.887 7.5 24 14.887 40.5 24 40.5"
  }
));
NeutralFace48.Size = 48;
NeutralFace48.Title = "NeutralFace";

export { NeutralFace48 as default };
